module.exports = __webpack_public_path__ + "static/media/edgeaudio-575x405.57edc9d9.jpg";